import { useTranslation } from 'react-i18next'

import { Choice } from 'src/components/CoffeeMatch/Choice/Choice'
import { Headline } from 'src/components/Headline/Headline'

import styles from './Question.module.scss'

import type { Choice as ChoiceType } from './Questions.data'

export interface CoffeeFinderQuestionProps {
  step: number
  choices: ChoiceType[]
  onQuestionAnswered: (choice: string) => void
}

export const Question = ({ step, choices, onQuestionAnswered }: CoffeeFinderQuestionProps) => {
  const { t } = useTranslation()

  const questionText = t(`coffeeMatch.questions.question-${step}`)

  return (
    <div className={styles.wrapper}>
      <Headline variant="h2">{questionText}</Headline>

      <div className={styles.choices}>
        {choices.map(({ value, hasDescription }) => (
          <Choice
            key={`answer-${value}`}
            value={value}
            hasDescription={hasDescription}
            onChoiceSelected={onQuestionAnswered}
          />
        ))}
      </div>
    </div>
  )
}
